import { Flex, Text } from "@mantine/core";
import type { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

import { VoiceAnswerLink } from "./voice-answer-link";
import { ResultsSection } from "./results-section";
import { MessageSenders } from "@/types/screeners";

interface TranscriptBlock {
  isVoiceResponse?: boolean;
  message: string;
  name: MessageSenders;
  rightSection?: ReactNode;
}

interface QuestionTranscriptProps {
  sessionId: string;
  transcript: TranscriptBlock[];
  title: string;
}

export const QuestionTranscript = ({
  sessionId,
  title,
  transcript,
}: QuestionTranscriptProps) => {
  return (
    <ResultsSection
      style={{ paddingBottom: 0, paddingLeft: 0, paddingRight: 0 }}
      title={<Text className="font-semibold px-5">{title}</Text>}
    >
      <Flex direction="column">
        {transcript.map(
          ({ isVoiceResponse, message, name, rightSection }, index) => {
            return (
              <Flex
                className={twMerge([
                  name === MessageSenders.Screener && "bg-uw-gray-0",
                  "px-5",
                  "py-3",
                ])}
                direction="column"
                key={`${name}_${index}`}
              >
                <Flex align="center" justify="space-between">
                  <Text
                    className="font-bold text-uw-gray-7 uppercase"
                    size="xs"
                  >
                    {name}
                  </Text>
                  {rightSection}
                </Flex>
                {isVoiceResponse ? (
                  <VoiceAnswerLink href={message} sessionId={sessionId} />
                ) : (
                  <Text className="text-uw-gray-9" size="sm">
                    {message}
                  </Text>
                )}
              </Flex>
            );
          },
        )}
      </Flex>
    </ResultsSection>
  );
};
